// src/pages/PrivacyPolicy.jsx
import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  background: #000000;
  color: #e0e0e0;
  min-height: 100vh;
  padding: 140px 2rem 6rem;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
`;

const Content = styled.div`
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
  font-size: 1.1rem;

  h1 {
    font-size: 3rem;
    font-weight: 700;
    color: #ffffff;
    text-align: center;
    margin-bottom: 1rem;
    letter-spacing: -0.5px;
  }

  .last-updated {
    text-align: center;
    color: #888888;
    font-size: 0.95rem;
    margin-bottom: 4rem;
    font-style: italic;
  }

  h2 {
    font-size: 1.6rem;
    font-weight: 600;
    color: #ffffff;
    margin: 3rem 0 1rem;
    border-bottom: 1px solid #333333;
    padding-bottom: 0.5rem;
  }

  p {
    color: #cccccc;
    margin-bottom: 1.2rem;
  }

  strong {
    color: #ffffff;
  }

  ul {
    margin: 1.2rem 0;
    padding-left: 1.8rem;
    color: #cccccc;
  }

  li {
    margin-bottom: 0.6rem;
  }

  a {
    color: #ffffff;
    text-decoration: underline;
    &:hover {
      color: #dddddd;
    }
  }

  .contact-info {
    background: #111111;
    border: 1px solid #333333;
    padding: 1.5rem;
    border-radius: 4px;
    margin: 2rem 0;
  }

  .back-link {
    display: block;
    text-align: center;
    margin-top: 5rem;
    font-size: 1.1rem;
    color: #ffffff;
    text-decoration: underline;
  }
`;

const PrivacyPolicy = () => {
  return (
    <Container>
      <Content>
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: November 25, 2025</p>

        <p>
          At <strong>Start Something Different (SSD) Recruitment</strong>, we are committed to protecting your privacy and ensuring that your personal information is handled securely and responsibly.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul>
          <li><strong>Personal Data:</strong> Name, email address, phone number, CV/resume, professional background, and any other information you voluntarily provide.</li>
          <li><strong>Usage Data:</strong> Information about how you interact with our website (e.g., pages visited, time spent).</li>
          <li><strong>Technical Data:</strong> IP address, browser type, device information, and cookies.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>We use your information to:</p>
        <ul>
          <li>Provide recruitment and career consulting services</li>
          <li>Match candidates with suitable job opportunities</li>
          <li>Communicate with you regarding inquiries or opportunities</li>
          <li>Improve our website and services</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2>3. Data Sharing</h2>
        <p>We do <strong>not</strong> sell your personal data. We only share your information with:</p>
        <ul>
          <li>Trusted clients (with your consent)</li>
          <li>Service providers under strict confidentiality</li>
          <li>Legal authorities when required by law</li>
        </ul>

        <h2>4. Data Security</h2>
        <p>We implement appropriate technical and organisational measures to protect your personal data.</p>

        <h2>5. Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access, correct, or delete your personal data</li>
          <li>Withdraw consent where applicable</li>
          <li>Request a copy of your data</li>
          <li>Lodge a complaint with a supervisory authority</li>
        </ul>

        <h2>6. Cookies</h2>
        <p>This website uses cookies to improve functionality. You can manage cookies in your browser settings.</p>

        <h2>7. Contact Us</h2>
        <div className="contact-info">
          <p>For any questions about this Privacy Policy or to exercise your rights:</p>
          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:privacy@ssdrecruitment.com">privacy@ssdrecruitment.com</a>
          </p>
        </div>

        <Link to="/" className="back-link">
          ← Back to Home
        </Link>
      </Content>
    </Container>
  );
};

export default PrivacyPolicy;